import BitmapTextField from "../views/components/BitmapTextField";
import Button from "../views/components/Button"
import SwitchButton from "../views/components/SwitchButton";
import TextField from "../views/components/TextField";
import ConsoleUtil from "./ConsoleUtil";


const fontSizeUnificationLabel = (
    buttons: Map<string, Button | SwitchButton>
) => {
    let fontSize: number = 1000;

    // find the smallest font size
    buttons.forEach((btn) => {
        let fs = btn.text.style.fontSize;
        
        if(Number(btn.text.style.fontSize) < fontSize) {
            fontSize = Number(btn.text.style.fontSize);
        }
    });

    // set the smallest font size on all texts
    buttons.forEach((btn) => {
        btn.text.style.fontSize = fontSize;
    });
}

const fontSizeUnificationText = (
    texts: Map<string, TextField | BitmapTextField>
) => {
    let fontSize: number = 1000;

    // find the smallest font size
    texts.forEach((txt) => {
        if (txt instanceof BitmapTextField) {
            ConsoleUtil.warn("fontSizeUnificationText is not implemented for bitmap fonts");
            return;
        }

        if (txt.visible) {
            let fs = Number(txt.element.style.fontSize);

            if(fs < fontSize) {
                fontSize = fs;
            }
        }
    });

    // set the smallest font size on all texts
    texts.forEach((txt) => {
        if (txt instanceof BitmapTextField) {
            ConsoleUtil.warn("fontSizeUnificationText is not implemented for bitmap fonts");
            return;
        }
        if(txt.visible) {
            txt.element.style.fontSize = fontSize;
            txt.fixFontSize = fontSize;
        }
    });
}

const ButtonUtils = {
    fontSizeUnificationLabel,
    fontSizeUnificationText
}

export default ButtonUtils;